"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthErrorHandleService = void 0;
const http_status_codes_1 = __importDefault(require("http-status-codes"));
const common_1 = require("../../common");
class AuthErrorHandleService {
}
exports.AuthErrorHandleService = AuthErrorHandleService;
AuthErrorHandleService.handleAuthResponseError = (error) => {
    if (error.isAxiosError && error.response && error.response.data && error.response.data.message) {
        const { key, token } = JSON.parse(error.response.data.message);
        switch (error.response.status) {
            case http_status_codes_1.default.UNAUTHORIZED:
                return new common_1.UnauthorizedHttpError(error.message);
            case http_status_codes_1.default.FORBIDDEN:
                return new common_1.ForbiddenHttpError(error.message, key, token);
            default:
                return new common_1.UnProcessableEntityHttpError(error.message, key);
        }
    }
    return new common_1.AuthError(error.message, error);
};
AuthErrorHandleService.handleRefreshResponseError = (error) => {
    let message;
    if (error.response?.status === http_status_codes_1.default.UNAUTHORIZED && error.isAxiosError) {
        if (error.response.data?.message) {
            if ((message = error.response.data.message) && message === common_1.UnauthorizedHttpError.EXPIRED_JWT_ERROR) {
                return new common_1.UnauthorizedHttpError(message); // 401 with message as string
            }
            const { key } = JSON.parse(error.response.data.message);
            return new common_1.UnauthorizedHttpError(error.message, key); // 401 with key in message JSON
        }
        return new common_1.UnauthorizedHttpError(error.message); // default 401
    }
    return new common_1.AuthError(error.message, error);
};
AuthErrorHandleService.handleChangePasswordResponseError = (error) => {
    if (error.isAxiosError && error.response && error.response.data && error.response.data.message) {
        const { key } = JSON.parse(error.response.data.message);
        switch (error.response.status) {
            case http_status_codes_1.default.UNPROCESSABLE_ENTITY:
                return new common_1.UnProcessableEntityHttpError(error.message, key);
            default:
                return new common_1.AuthError(error.message, error);
        }
    }
    return new common_1.AuthError(error.message, error);
};
//# sourceMappingURL=AuthErrorHandleService.js.map